"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subtitle = void 0;
const react_1 = __importDefault(require("react"));
require("./subtitle.css");
const colorDefault = "#5c0f8b";
;
/**
 * Main component.
 * @name Subtitle
 * @param {SubtitleProps}
 * @returns {<Subtitle />}
*/
const Subtitle = ({ message, color = colorDefault }) => {
    return react_1.default.createElement("h3", { "data-testid": "subtitle-element", className: "subtitle-container", style: { color: color } }, message);
};
exports.Subtitle = Subtitle;
//# sourceMappingURL=subtitle.js.map